import type { MonospaceIndex, MonospaceIndexField } from '#layers/data-model/public';
import { RStoreSchema } from '#imports';

export const IndexField = RStoreSchema.withItemType<MonospaceIndexField>().defineCollection({
	name: 'MonospaceIndexField',
	scopeId: 'monospace-default',
	getKey: (item) => `${item.indexId}__${item.fieldId}`,
	meta: {
		defaultFields: ['indexId', 'fieldId', 'order'],
		useWorkspaceSlug: true,
	},
});

export const Index = RStoreSchema.withItemType<MonospaceIndex>().defineCollection({
	name: 'MonospaceIndex',
	scopeId: 'monospace-default',
	meta: {
		defaultFields: ['id', 'dbName', 'kind', 'collectionId'],
		useWorkspaceSlug: true,
	},
});
